import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatMenuModule} from '@angular/material/menu';
import { MatButtonModule} from '@angular/material/button';
import { MatExpansionModule} from '@angular/material/expansion';
import { MatTableModule} from '@angular/material/table';
import { MatPaginatorModule} from '@angular/material/paginator';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { ComplianceRoutingModule } from './compliance-routing.module';
import { PublicAccessComponent } from './public-access/public-access.component';
import { LcaComponent } from './lca/lca.component';
import { FdnsVisitComponent } from './fdns-visit/fdns-visit.component';
import { ComplianceComponent } from './compliance.component';
import { SharedModule } from '../shared/shared.module';
import {TabViewModule} from 'primeng/tabview';
import {TableModule} from 'primeng/table';
import {AccordionModule} from 'primeng/accordion';
import {CalendarModule} from 'primeng/calendar';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {PaginatorModule} from 'primeng/paginator';
import { FdnsQaComponent } from './fdns-qa/fdns-qa.component';
import { ManageFdnsVisitComponent } from './manage-fdns-visit/manage-fdns-visit.component';
import { PrimeFileUploadComponent } from './prime-file-upload/prime-file-upload.component';
import { I9FormsComponent } from './i9-forms/i9-forms.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PastDocumentsComponent } from './past-documents/past-documents.component';
import { PrimengLibraryModule } from 'primeng-library';
import { PastDocumentsMenuComponent } from './past-documents-menu/past-documents-menu.component';


@NgModule({
  declarations: [PublicAccessComponent, LcaComponent, FdnsVisitComponent, ComplianceComponent, FdnsQaComponent, ManageFdnsVisitComponent, PrimeFileUploadComponent, I9FormsComponent, PastDocumentsComponent, PastDocumentsMenuComponent, FdnsVisitComponent],
  imports: [
    PrimengLibraryModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ComplianceRoutingModule,
    MatTabsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDividerModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    ScrollingModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatToolbarModule,
    MatInputModule,
    MatRadioModule,
    MatCardModule,
    MatSidenavModule,
    MatMenuModule,
    MatButtonModule,
    PdfViewerModule,
    MatExpansionModule,
    MatTableModule,
    MatPaginatorModule,
    SharedModule,
    TabViewModule,
    TableModule,
    MatStepperModule,
    AccordionModule,
    CalendarModule,
    InputTextareaModule,
    PaginatorModule,
    NgxExtendedPdfViewerModule
  ],
  exports: [FdnsVisitComponent]
})
export class ComplianceModule { }
